<div class="terms-section-box rounded bg-white py-3">
  <div
    *ngIf="termsAndConditions; else defaultTemplate"
    class="terms-section-content text-left mb-3"
    [innerHtml]="termsAndConditions.BodyText | safeHtml"
  ></div>
  <ng-template #defaultTemplate>
    <ng-container [ngTemplateOutlet]="defaultTerms"></ng-container>
    <ng-container *ngIf="!defaultTerms">Default terms and conditions were not set</ng-container>
  </ng-template>
</div>
